// @flow
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import React, { Fragment, useEffect } from 'react';
import Slider from 'react-slick';
import cx from 'classnames';
import ProductCard from 'components/common/ProductCard';
import type { ProductItem } from 'store/modules/display';
import FakeProductCard from 'components/common/FakeProductCard';
import ArrowRight from 'components/common/Arrow/ArrowRight';
import ArrowLeft from 'components/common/Arrow/ArrowLeft';
import './ProductCardList.scss';

type Props = {
  products?: ?(ProductItem[]),
  loading: boolean,
  prefetching: boolean,
  width?: number,
  hasEnded: boolean,
  oneColumn?: boolean,
  placeholderCount?: number,
  hideUsername?: boolean,
  isTrending?: boolean,
};

const createArray = length => Array.from(Array(length).keys());
const getColumnCount = width => {
  const xWide = 1920;
  const wide = 1600;
  const xLarge = 1256;
  const large = 1024;
  const medium = 768;

  if (!width) return 1;

  if (width < medium) return 4;
  if (width < large) return 6;
  if (width < xLarge) return 6;
  if (width < wide) return 6;
  if (width < xWide) return 12;
  return 12;
};

const ProductCardList = ({
  products,
  loading,
  prefetching,
  width,
  hasEnded,
  oneColumn,
  placeholderCount,
  hideUsername,
  isTrending,
}: Props) => {
  const trendingCount = oneColumn ? 1 : getColumnCount(width);
  const fakeProductList = createArray(trendingCount).map(num => (
    <FakeProductCard key={num} oneColumn={oneColumn} isTrending={isTrending} />
  ));
  if (loading) {
    return <div className={cx('ProductCardList')}>{fakeProductList}</div>;
  }

  if (!products) return null;

  // 중복된 상품 ID 제거
  const uniqueProducts = products.filter(
    (product, index, self) => index === self.findIndex(p => p.id === product.id),
  );

  const productList = uniqueProducts.map(product => (
    <ProductCard
      key={product.id}
      id={product.id}
      thumbnail={product.thumbnail}
      username={product.user.username}
      displayName={product.user.display_name}
      userThumbnail={product.user.thumbnail}
      title={product.title}
      badges={product.badges}
      body={(product.meta && product.meta.short_description) || product.body}
      price={product.meta && product.meta.price}
      supplier={(product.meta && product.meta.supplier) || '-'}
      date={product.released_at}
      urlSlug={product.url_slug}
      oneColumn={oneColumn}
      commentsCount={product.comments_count}
      isPrivate={product.is_private}
      hideUsername={hideUsername}
    />
  ));

  if (productList && productList.length === 0)
    return (
      <div className={cx('ProductCardList')}>
        <div className="empty-list">아직 등록된 상품이 없습니다.</div>
      </div>
    );

  return (
    <Fragment>
      <div className={cx('ProductCardList')}>
        {productList}
        {prefetching && fakeProductList}
      </div>
    </Fragment>
  );
};

ProductCardList.defaultProps = {
  products: [],
  oneColumn: false,
  width: 0,
  placeholderCount: 36,
  hideUsername: false,
  hasEnded: false,
  prefetching: false,
};

export default ProductCardList;



// WEBPACK FOOTER //
// ./src/components/common/ProductCardList/ProductCardList.js